import { ListItemText } from '@mui/material';
import Divider from '@mui/material/Divider';
import ListItemIcon from '@mui/material/ListItemIcon';
import AppsIcon from '@mui/icons-material/Apps';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import { useRef } from 'react';
import { Link } from 'react-router';
import { AdminPortal } from '@frontegg/react';
import { isDebugMode } from '../../debug/debugUser';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import LogoutIcon from '@mui/icons-material/Logout';
import { useOutsideClick } from '../../hooks/useOutsideClick';
import { logout } from '../../services/hooks/useAuthActions';
import { PermissionService } from '../../services/PermissionService';
import { PermissionKey } from '../../services/PermissionAndRolesKeys';
import { ROUTES } from '../../constants/RouteNameMapping';
import { AccountSwitcher } from './AccountSwitcher';

interface IAccountMenuProps {
  onCloseMenu: () => void;
}

export function AccountMenu({ onCloseMenu }: IAccountMenuProps) {
  const canViewUserAdminPortal =
    !isDebugMode() && PermissionService.get().hasPermission(PermissionKey.canViewUserAdminPanel);
  // Switching between customers is a Customer Success tool; a customer user
  // with several memberships reaches each one on its own subdomain
  const canSwitchAccounts =
    !isDebugMode() && PermissionService.get().hasPermission(PermissionKey.customerSuccessAll);
  const ref = useRef(null);
  function showUserAdminPortal() {
    onCloseMenu();
    AdminPortal.show();
  }

  useOutsideClick(ref, () => onCloseMenu());

  return (
    <MenuList>
      <Link
        to={`${ROUTES.INTEGRATIONS}/${ROUTES.INTEGRATIONS_APPS}`}
        style={{ textDecoration: 'none', color: 'unset' }}
        onClick={onCloseMenu}
      >
        <MenuItem>
          <ListItemIcon>
            <AppsIcon />
          </ListItemIcon>
          <ListItemText>Integrations</ListItemText>
        </MenuItem>
      </Link>
      {canViewUserAdminPortal && (
        <MenuItem onClick={showUserAdminPortal}>
          <ListItemIcon>
            <AdminPanelSettingsIcon />
          </ListItemIcon>
          <ListItemText>User Management</ListItemText>
        </MenuItem>
      )}
      {canSwitchAccounts && <AccountSwitcher onCloseMenu={onCloseMenu} />}
      <Divider />
      <MenuItem onClick={logout}>
        <ListItemIcon>
          <LogoutIcon />
        </ListItemIcon>
        <ListItemText>Log out</ListItemText>
      </MenuItem>
    </MenuList>
  );
}
